export default (that) => [
  {
    type: 'seq',
    title: '#',
    width: 46,
    fixed: 'left',
    align: 'center',
  },
  {
    field: 'editContainerNo',
    title: that.$l('table_label_editContainerNo') || '编辑柜号',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'containerName',
    title: that.$l('table_label_containerType') || '柜型',
    width: 90,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'containerBoxQty',
    title: that.$l('table_label_ctnQty') || '箱数',
    width: 70,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'containerVolume',
    title: that.$l('table_label_volume') || '体积(m³)',
    width: 90,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalWeight',
    title: that.$l('table_label_totalWeightKg') || '总重(kg)',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_bookingNo') || '订舱单号',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'bookingNo' },
  },
  {
    title: that.$l('table_label_customsNo') || '关单号',
    minWidth: 130,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'customsNo' },
  },
  {
    field: 'containerCostAmount',
    title: that.$l('table_label_costAmount') || '成本金额',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ row }) =>
      [
        row.costCurrencyUnitName || row.costCurrencyUnit,
        row.containerCostAmount || '0',
      ]
        .filter(Boolean)
        .join(' '),
  },
  {
    field: 'containerSalePriceAmount',
    title: that.$l('table_label_salesAmount') || '销售金额',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ row }) =>
      [
        row.salesCurrencyUnitName || row.salesCurrencyUnit,
        row.containerSalePriceAmount || '0',
      ]
        .filter(Boolean)
        .join(' '),
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    width: 60,
    fixed: 'right',
    align: 'center',
    slots: { default: 'remove' },
  },
]
